<script lang="ts">
  import moment from "moment";

  // services
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import { download } from "@shared/svelte/Modules/Download.svelte";

  // components
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import OrderSuccessDetail from "@retailer/svelte/Order/Components/OrderSuccessDetail.svelte";
  import ProviPayBanner from "@retailer/svelte/Order/Components/ProviPayBanner.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  // types
  import type { OrderGroup } from "@shared/types/OrderGroup";
  import type { RetailerType } from "@shared/types/Retailer";

  export let newOrderReceivedWithCcRollout: string = null;
  export let orderGroup: OrderGroup;
  export let retailer: RetailerType;
  export let showStreamlinedAOOActionRequired: boolean = false;

  const city = [retailer.city, retailer.state, retailer.zip].filter(value => !!value).join(", ");

  const isProviPayEligible: boolean =
    retailer.term_payments &&
    !!orderGroup.orders.find(order => order.distributor.uses_term_payments);
</script>

<div class="fizz-flex-row fizz-stack-32" />
<div class="fizz-flex-row fizz-space-between fizz-stack-24">
  <Icon type="CheckCircle" extraClassNames="color-brandSecondary fizz-icon-48" />
  <button class="fizz-button fizz-button-small" on:click={() => download(orderGroup.id)}>
    Print Order
  </button>
</div>
<div class="fizz-flex-row fizz-stack-48">
  <div>
    <div class="fizz-heading-2 fizz-stack-4"
      >Thank you for sending your {pluralize("order", orderGroup.orders.length)} with Provi!</div
    >
    {#if !!newOrderReceivedWithCcRollout}
      <div class="fizz-alert-info fizz-stack-16">
        <p><strong>We're improving order transparency</strong></p>
        <p>
          That's why we're including you on order submission emails with your sales rep at {newOrderReceivedWithCcRollout}.
          Provi exists to provide a better way to order your beverages and our goal is to ensure you
          have a seamless experience.
        </p>
      </div>
    {/if}
    <div class="fizz-text-large fizz-stack-8">
      Check your email <strong>{window["$rootScope"].user?.email}</strong> for more information on your
      order status.
    </div>
  </div>
</div>
<div class="fizz-flex-row fizz-heading-4 fizz-stack-16">Order Details</div>
<div class="fizz-flex-row-responsive fizz-text-medium fizz-stack-32 fizz-align-content-start">
  <div class="fizz-flex-item">
    <p class=" fizz-text-strong">Order Date</p>
    <p>{moment(orderGroup.submitted_at).format("MMMM DD, YYYY")}</p>
  </div>
  <div class="fizz-flex-item">
    <p class="fizz-text-strong">Order Group #</p>
    <p>{orderGroup.id}</p>
  </div>
  <div class="fizz-flex-item">
    <p class="fizz-text-strong">Retail Location</p>
    <p>{retailer.name}</p>
    <p>{retailer.address1}</p>
    <p>{city}</p>
  </div>
</div>
{#if isProviPayEligible}
  <ProviPayBanner {orderGroup} />
{/if}
<div class="fizz-flex-row fizz-heading-4 fizz-stack-16">Order Summary</div>
{#each orderGroup.orders as order}
  <OrderSuccessDetail {order} {showStreamlinedAOOActionRequired} />
{/each}
<div class="fizz-flex-row grid-col fizz-stack-16">
  <UIRouterLink stateName="layout.order_groups" button={true} params={{}}>
    <button class="fizz-button">View All Orders</button>
  </UIRouterLink>
</div>
